export function normalizeText(value: string): string {
  return String(value || '').trim().replace(/\s+/g, ' ');
}

export function truncateText(value: string, maxLength: number): string {
  const normalizedValue = normalizeText(value);

  if (maxLength <= 0) {
    return '';
  }

  if (normalizedValue.length <= maxLength) {
    return normalizedValue;
  }

  if (maxLength <= 3) {
    return '.'.repeat(maxLength);
  }

  return `${normalizedValue.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

export function splitTextPreview(
  value: string,
  leadMaxLength: number,
  totalMaxLength: number,
): { lead: string; continuation: string } {
  const preview = truncateText(value, totalMaxLength);

  if (preview.length <= leadMaxLength) {
    return { lead: preview, continuation: '' };
  }

  const wordBoundary = preview.lastIndexOf(' ', leadMaxLength);
  const splitIndex = wordBoundary > 0 ? wordBoundary : leadMaxLength;

  return {
    lead: preview.slice(0, splitIndex).trimEnd(),
    continuation: preview.slice(splitIndex).trimStart(),
  };
}

export function interpolateText(
  value: string,
  variables: Record<string, string | number>,
): string {
  return value.replace(/\{(\w+)\}/g, (placeholder, key: string) => {
    const replacement = variables[key];
    return replacement === undefined ? placeholder : String(replacement);
  });
}
